import React, { useEffect, useState } from "react";
import "./styelPaymentDetails.css"
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { getOrderHistorySync, updateOrderHistory } from "../../../services/revenueServices";
import { useDispatch, useSelector } from "react-redux";
import { setTxnReqList } from "../../../features/revenue/revenueSlice";

const INCSUBPaymentDetails = ({ onClose, orderId }) => {

    const [historyLoader, setHistoryLoader] = useState(false);
    const [orderDetails, setOrderDetails] = useState();
    const [transactionId, setTransactionId] = useState('');

    const dispatch = useDispatch()
    const txnReqList = useSelector((state) => state.revenue.txnReqList)
    const navigate = useNavigate();
    const handleOrderHistory = async (orderId) => {
        setHistoryLoader(true);
        try {
            const txnData = await getOrderHistorySync(orderId);
            if (txnData.status === 200) {
                setOrderDetails(txnData.data.data)
            } else if (txnData.status === 301) {
                toast.error("Network Error");
            } else if (txnData.status === 500) {
                toast.error("Internal server error");
            } else if (txnData.status === 401) {
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (![200, 401].includes(txnData.status)) {
                toast.error(txnData.data.message)
            }

        } catch (error) {
            toast.error("Something went wrong")
        } finally {
            setHistoryLoader(false);
        }


    }
    const [error, setError] = useState();
    const [btnLoader, setBtnLoader] = useState(false);
    const handleUpdate = async () => {
        const data = { paymentRequestId: orderDetails.paymentRequestId, transactionId: transactionId }
        if (transactionId !== "") {
            setBtnLoader(true)
            try {
                const txnData = await updateOrderHistory(data);
                if (txnData.status === 200) {
                    const updatedData = txnReqList.paymentRequestList.filter((txn) => txn.paymentRequestId !== orderDetails.paymentRequestId)
                    dispatch(setTxnReqList({
                        ...txnReqList,
                        paymentRequestList: updatedData
                    }));
                } else if (txnData.status === 301) {
                    toast.error("Network Error");
                } else if (txnData.status === 500) {
                    toast.error("Internal server error");
                } else if (txnData.status === 401) {
                    window.localStorage.setItem('userData', null);
                    window.localStorage.setItem('token', null);
                    navigate('/login');
                } else if (![200, 401].includes(txnData.status)) {
                    toast.error(txnData.data.message)
                }
                onClose(false)
            } catch (error) {
                toast.error("Something went wrong")
            } finally {
                setBtnLoader(false)
            }
        } else {
            setError(true)
        }
    }
    useEffect(() => {
        if (orderId) {
            handleOrderHistory(orderId);
        }
    }, [])

    return (
        <div className="popup-overlay" onClick={() => onClose(false)}>
            <div className="popup" onClick={(e) => e.stopPropagation()}>
                {!historyLoader && orderDetails ? <>
                    <h2>Payment Details</h2>
                    <ul className="payment-details">
                        <li><strong>User Name:</strong> {orderDetails.userName}</li>
                        <li><strong>User Mobile Number:</strong> {orderDetails.userMobileNumber}</li>
                        <li><strong>Amount:</strong> ₹{orderDetails.amount.toFixed(2)}</li>
                        <li><strong>UPI ID:</strong> {orderDetails.upiId}</li>
                        <li><strong>Pool Name:</strong> {orderDetails.poolName}</li>
                        <li><strong>Payment Request ID:</strong> {orderDetails.paymentRequestId}</li>
                        <input className="INCSUBTxnNo" placeholder="Enter Transaction ID" style={{ border: transactionId === "" && error ? "2px solid red" : null }} value={transactionId} onChange={(e) => setTransactionId(e.target.value)}></input>
                    </ul>


                    <button className="close-btn" onClick={() => !btnLoader ? handleUpdate() : null}>{!btnLoader ? "Done" : <div className='btnLoader' />}</button>
                </> : <div className="orderDetails_loader_container"><div className='categoryloader' /> </div>}
            </div>
        </div>
    );
};

export default INCSUBPaymentDetails;
